<app-page-meta pageTitle="finzy - Privacy Policy"
               tags="finzy, peer to peer lending, peer to peer lending india, line of credit online, easy finance, need a loan, india credit finance, personal loans, easy loans, loan, loan india, current loan rates india, best loans india, best loan rates, cheapest loans india, high investment investment opportunities, investments, quick personal loans, low interest personal loans"
               description="Welcome to finzy.com, a portal run by Bridge Fintech Solutions Private Limited (“finzy”). finzy is committed to respecting your online privacy and recognizes your need for appropriate protection and management of any information you share with finzy on finzy.com (the “Website”).">
</app-page-meta>

<app-header></app-header>
<div class="ppmainrow">
  <div class="ppmaindiv">
          <p class="pphead">PRIVACY POLICY</p>

          <div>
            <ol type=1>
              <li>Introduction
                <br>
                Welcome to finzy.com, a portal run by Bridge Fintech Solutions Private Limited (“finzy”). finzy is committed to respecting your online privacy and recognizes your need for appropriate protection and management of any information you share with finzy on finzy.com (the “Website”).
              </li>
              <br>
              <br>


              <li>Scope
                <br>
                This privacy policy (“Policy”) is an electronic record in the form of an electronic contract formed under the Information Technology Act, 2000 and the rules made thereunder. This Policy does not require any physical, electronic or digital signature. This Policy is a legally binding document between you and finzy. The terms of this Policy will be effective upon your acceptance of the same, by clicking on the "I Accept" tab or by use of the Website and will govern the relationship between you and finzy for your use of the Website.
              </li>
              <br>
              <br>

              <li>Consent
                <br>
                By mere use of the Website, you expressly consent to finzy’s use and disclosure of your Personal Information in accordance with this Policy. If you do not agree with the terms of this Policy, please do not use this Website. This Policy shall be deemed to be incorporated into the Terms of Service of the Website and shall be read in conjunction to the Terms of Service. By using the Website, you hereby consent to and authorise finzy to a) conduct a background check on you including but not limited to a Know Your Customer verification either by itself or through any third party(ies) and b) authenticating the veracity of the identity, location and documents submitted by you, either by itself or through any third party(ies) and c) to share your Personal Information for this purpose.
              </li>
              <br>
              <br>


              <li>What Information Is Collected
                <br>
                <ol style="list-style-type: none;">
                  <li>4.1. &nbsp;The Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011 defines “Personal Information” as any information that relates to a natural person, which, either directly or indirectly, in combination with other information available or likely to be available with a body corporate, is capable of identifying such person.</li>
                  <br>
                  <li>4.2. &nbsp;For the purpose of this Policy, the term “Personal Information” shall mean any document/information you provide to finzy and shall include, without limitation your name, phone number, your address, your date of birth, your e-mail address, your gender, your photograph, your occupation, your financial information such as bank account, bank account statement or credit card or debit card or other payment details, your permanent account number, aadhaar number, your other identity proof document number, your address proof document number, your salary slip, details of your income tax returns, your tax deducted at source statement, your credit information report, your details from databases, your social media activity, your login ID and password and similar other information</li>
                  <br>
                  <li>4.3. &nbsp;For the purpose of this Policy, the term “Non-Personal Information” shall mean information that does not specifically identify an individual but includes information from you, such as the type of internet browser you use, mobile device you use, your computer or your mobile device’s unique device ID, the URL of the previous website you visited, your computer’s operating system, your Internet Service Provider (ISP) and your Internet Protocol (IP) address. finzy may also collect Non-Personal Information that you voluntarily provide, such as information included in response to a questionnaire or a survey conducted by finzy.</li>
                  <br>
                </ol>
              </li>
              <br>
              <br>


              <li>Collection of Information
                <br>
                <ol style="list-style-type: none;">
                  <li>5.1. &nbsp;finzy may collect information/documents from you when you register on the Website, when you create a profile on the Website, when you update your profile on the Website, when you use the features on the Website, when you participate in surveys conducted by finzy on the Website and when you carry out transactions on the Website.</li>
                  <br>
                  <li>5.2. &nbsp;finzy may use cookies to monitor the Website usage including, without limitation, to provide useful features to simplify your experience when you return to the Website, like remembering your login ID and certain Personal Information and to deliver relevant content based on your preferences, usage patterns and location.</li>
                  <br>
                  <li>5.3. &nbsp;You may use the Website without providing finzy any Personal Information about you. However, you may not be able to access certain services of the Websites in case you choose to do so.</li>
                </ol>
              </li>
              <br>
              <br>



              <li>Use of Information
                <br>
                finzy uses your Personal and Non-Personal Information for certain purposes including but not limited to:
                <br>
                  <ol style="list-style-type: none;">
                    <li>6.1. &nbsp;Service-related Purpose</li>
                    <br>
                        <ol style="list-style-type: none;">
                          <li>6.1.1. &nbsp;Responding to your queries and carrying out the transactions you have requested for;</li>
                          <br>
                          <li>6.1.2. &nbsp;Enabling you to use the Website;</li>
                          <br>
                          <li>6.1.3. &nbsp;Providing you with information about services available on the Website;</li>
                          <br>
                          <li>6.1.4. &nbsp;Resolving any glitches on the Website including addressing any technical problems; </li>
                          <br>
                          <li>6.1.5. &nbsp;improving your experience of navigating through the Website, connecting you with potential lenders and carrying out transactions on the Website; </li>
                          <br>
                          <li>6.1.6. &nbsp;enforcing finzy’s rights and/or that of the potential lenders in case you are a Borrower (as defined in the Terms of Service); and</li>
                          <br>
                          <li>6.1.7. &nbsp;Improving the services and content on the Website.</li>
                        </ol>
                        <br>
                      <li>6.2. &nbsp;Internal Business Purpose
                        <br>
                        finzy may use your Personal and Non-Personal Information for internal business purposes, such as data analysis, research, developing new features, enhancing and improving existing services and in identifying usage trends. This information helps finzy to constantly improve, personalize and customize the services it provides to you.
                      </li>
                  </ol>
               </li>
               <br>
               <br>


               <li>Sharing of Information
                <br>
                finzy may disclose your Personal Information in the following ways:
                  <ol style="list-style-type: none;">
                    <li>7.1. &nbsp;Disclosure to Government Authorities/ Regulators or as required by law</li>
                    <br>
                        <ol style="list-style-type: none;">
                          <li>7.1.1. &nbsp;finzy may share your Personal Information with Credit Rating Agencies, Credit Information Companies and the Reserve Bank of India and other regulators in accordance with the applicable laws and in order to effectively provide the services on the Website.</li>
                          <br>
                          <li>7.1.2. &nbsp;finzy may share your Personal Information with Government and/or statutory authorities in response to subpoenas, court orders, or other legal process; to establish or exercise legal rights; to defend against legal claims; or as otherwise required by law. finzy warrants that such information will be disclosed only in accordance with applicable laws and regulations.</li>
                        </ol>
                        <br>

                    <li>7.2. &nbsp;Disclosure to other registered user
                      <br>
                       A lot of personal information will be disclosed with listing and at the time of documentation the name of the borrower is also disclosed. So it wld be possible for a Lender to piece together pre documentation and post documentation information
                    </li>
                    <br>

                    <li>7.3. &nbsp;Disclosure to Acquirers
                      <br>
                      finzy may disclose and/or transfer your Personal Information to an acquirer, assignee or other successor entity in connection with a sale, merger, or reorganization of all or substantially all of the equity, business or assets of finzy.
                    </li>
                    <br>

                    <li>7.4. &nbsp;Disclosure to Facilitate Payment
                      <br>
                      In order to process your transactions, finzy may direct you to a payment gateway service or any other payment service provider of its own choice, which may have access to the Personal Information provided by you while making such payment.
                    </li>
                    <br>

                    <li>7.5. &nbsp;Disclosure to Third Parties
                      <br>
                      finzy may engage third parties like the document collection agents, recovery agents, service centres, collection agents, in order to provide various services to finzy. If any such third party must have access to your Personal Information in order to perform its services, finzy will require that third party ensures confidentiality and disclosure restrictions outlined in this Policy.
                    </li>
                   </ol>
               </li>
               <br>
               <br>

               <li>Protection of Information
                <br>
                  <ol style="list-style-type: none;">
                    <li>8.1. &nbsp;finzy has taken adequate measures to protect the security of your Personal Information and to ensure that your choices for its intended use are honoured. finzy takes adequate precautions to protect your data from loss, misuse, unauthorized access or disclosure, alteration, or destruction.</li>
                    <br>
                    <li>8.2. &nbsp;finzy assures you that your information is safe and secure. It uses industry standards, and physical, technical and administrative security measures to keep your Personal Information confidential and secure and finzy shall not share your Personal Information with third parties, except as otherwise provided in this Policy.</li>
                    <br>
                    <li>8.3. &nbsp;At finzy, data is stored in password-controlled servers with limited access to employees and other personnel or consultants on a need-to-know basis.</li>
                    <br>
                    <li>8.4. &nbsp;finzy uses the encryption technology called AES 256 (Advanced Encryption Standard), which helps to protect your payment information such as your credit/debit card number, credit/debit card expiry date, your CVV number etc. Please note that e-mails, messaging and means of communication with finzy are not encrypted, and therefore finzy strongly advises you not to communicate any confidential information through these means.</li>
                    <br>
                    <li>8.5. &nbsp;Access to your online account on the Website is password protected and this helps to secure your account information. You are solely responsible for maintaining the confidentiality of that password. To ensure safety of your Personal Information, you are advised against sharing your user name and password with anyone.</li>
                    <br>

                  </ol>
               </li>
               <br>
               <br>


               <li>Cookies and Other Tracking Technologies
                <br>
                    <ol style="list-style-type: none;">
                      <li>9.1. &nbsp;The Website utilizes cookies and other tracking technologies including any proprietary or third party tracking services. A cookie is a small text file that may be used, for example, to collect information about the Website activity. Some cookies and other technologies
                      may serve to recall Personal and/or Non-Personal Information previously indicated by a Website user. Most browsers allow you to control cookies, including whether or not to accept them and how to remove them. </li>
                      <br>
                      <li>9.2. &nbsp;You may set most browsers to notify you if you receive a cookie, or you may choose to block cookies with your browser, however, if you choose to erase or block your cookies, you shall have to re-enter your original user ID and password to gain access to certain parts of the Website.</li>
                      <br>
                      <li>9.3. &nbsp;Tracking technologies may record information such as internet domain and host names, internet protocol (IP) addresses, browser software and operating system types, clickstream patterns, and dates and times at which the Website is accessed. Our use of cookies and other tracking technologies allow us to improve our Website and your experience in using our Website.</li>
                    </ol>
               </li>
               <br>
               <br>

               <li>Limitation of Liability
                <br>
                    <ol style="list-style-type: none;">
                      <li>10.1. &nbsp;finzy is not responsible for any breach of security or for any actions or inactions of any third parties that receive your Personal Information.</li>
                      <br>
                      <li>10.2. &nbsp;finzy is linked to many other sites and we are not/shall be not responsible for their privacy policies or practices as it is beyond our control</li>
                      <br>
                      <li>10.3.&nbsp;Notwithstanding anything contained in this Policy or elsewhere, finzy shall not be held responsible for any loss, damage or misuse of your Personal Information, if such loss, damage or misuse is attributable to a Force Majeure Event (as defined below).</li>
                      <br>
                      <li>10.4. &nbsp;A “Force Majeure Event” shall mean any event that is beyond the reasonable control of finzy and shall include, without limitation, sabotage, fire, flood, explosion, acts of God, civil commotion, strikes, lockouts or industrial action of any kind, riots, insurrection, war, acts of government, computer hacking, civil disturbances, unauthorised access to computer data and storage device, computer crashes, breach of security and encryption, and any other similar events not within the control of finzy and which finzy is not able to overcome.</li>
                    </ol>
               </li>
               <br>
               <br>


               <li>Opt-Out
                <br>
                You have the option to 'opt-out' of all finzy’s newsletters and other general e-mail marketing communications. finzy respects your privacy and in the event that you choose to not receive such mailers, it shall take all adequate steps to remove you from such lists. However, you will not be able to opt-out of receiving administrative messages, customer service responses or other transactional communications.
               </li>
               <br>
               <br>


               <li>Changes to this Policy
                <br>
                finzy reserves the right to update, change or modify this Policy at any time. The Policy shall come to effect from the date of such update, change or modification.
               </li>
               <br>
               <br>


               <li>Grievance Officer
                <br>
                In accordance with the Information Technology Act, 2000 and Rules made thereunder, the name and contact details of the Grievance Officer are provided below:
                <br>
                   Name: John Stain Richard<br/>
                   Address: Bridge Fintech Solutions Private Limited, 118, 1st Floor, 80 Feet Road, Koramangala 7th Block, Bengaluru, Karnataka - 560095.<br/>
                   E-mail:  <a href="mailto:grievances@finzy.com">grievances@finzy.com</a><br/>
               </li>
               <br>
               <br>


               <li>How to Contact Us
                <br>
                   If you have questions or concerns about this Policy, please contact us at <a href="mailto:support@finzy.com">support@finzy.com</a> or call us on +91 9341 300 300.
               </li>



            </ol>
          </div>
  </div>
</div>


<app-footer></app-footer>
